<template>
  <div>
    <span
      class="q-pa-sm hover-active block cursor-pointer"
      outline
      @click="open"
    >
      <span class="bold">{{
        $t("universal_search_actionsheet_select_source_filter.sources")
      }}</span>
      {{ selectedSourcesLabel }}
    </span>

    <QDialog
      v-model="show"
      position="bottom"
      square
    >
      <QCard class="full-width overflow-hidden">
        <QCardSection class="header row q-pa-md justify-between">
          <QBtn
            dense
            flat
            :label="
              $t('universal_search_actionsheet_select_source_filter.back')
            "
            size="12px"
            @click="close"
          />
          <span class="title bold block">{{
            $t("universal_search_actionsheet_select_source_filter.sources")
          }}</span>
          <QBtn
            dense
            flat
            :label="
              $t('universal_search_actionsheet_select_source_filter.done')
            "
            size="12px"
            @click="saveAndClose"
          />
        </QCardSection>

        <FiltersAutocomplete
          v-model="localSources"
          class="bottom-space"
          filter-type="sources"
          keep-expanded
          :media="searchEnabledMedia"
          :placeholder="displayPlaceholder"
          :stream="localStream"
        />
      </QCard>
    </QDialog>
  </div>
</template>

<script>
import FiltersAutocomplete from "shared/components/core/forms/FiltersAutocomplete.vue";
import { getMediaForStream } from "shared/helpers/media";

export default {
  name: "UniversalSearchActionsheetSelectSourceFilter",
  components: {
    FiltersAutocomplete,
  },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    stream: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      show: false,
      localSources: [...this.modelValue],
      localStream: this.stream,
    };
  },
  computed: {
    displayPlaceholder() {
      return this.$isMobile
        ? this.$t("universal_search_actionsheet_select_source_filter.sources")
        : "";
    },
    selectedSourcesLabel() {
      if (this.localSources.length) return `(${this.localSources.length})`;

      return "";
    },
    searchEnabledMedia() {
      return getMediaForStream(this.stream);
    },
  },
  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.localSources = [...this.modelValue];
      },
    },
  },
  methods: {
    open() {
      this.localSources = [...this.modelValue];
      this.show = true;
    },
    close() {
      this.show = false;
    },
    saveAndClose() {
      this.$emit("update:modelValue", this.localSources);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: 1px solid #ddd;
}

.title {
  font-size: 19px;
}

.bottom-space {
  height: 550px;
  max-height: 550px;
}
</style>
